import type { SVGProps } from "react";
import { memo } from "react";
const InteractiveVideoService = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#C8511B" />
        <stop offset="100%" stopColor="#F90" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="m66 46.283-10.478-6.05L66 34.184zM34 50.17V30.298l17.21 9.936zm-2-23.339-10.478-6.049L32 14.732zm0 38.908-10.478-6.05L32 53.64zm35.5-34.153a1 1 0 0 0-1 0L53.366 39.17 34 27.99V13a.998.998 0 0 0-1.5-.866l-13.478 7.781a1.002 1.002 0 0 0 0 1.733L32 29.14v22.19l-12.978 7.493a1 1 0 0 0 0 1.732L32.5 68.337a1 1 0 0 0 1 0 1 1 0 0 0 .5-.867V52.48l19.366-11.182L66.5 48.881a.998.998 0 0 0 1.5-.866V32.452a1 1 0 0 0-.5-.866M48 65.734V53.635l10.478 6.05zm12.978-6.915L47.5 51.037a.998.998 0 0 0-1.5.866v15.563a.997.997 0 0 0 1 1 1 1 0 0 0 .5-.134l13.478-7.78a1.002 1.002 0 0 0 0-1.733M14 46.283v-12.1l10.478 6.05zm13.478-6.05c0-.358-.191-.688-.5-.867L13.5 31.586a1 1 0 0 0-1.5.866v15.562a1 1 0 0 0 1.5.867L26.978 41.1c.309-.179.5-.509.5-.866M48 14.733l10.478 6.05L48 26.83zm-1.5 14.696a1 1 0 0 0 1 0l13.478-7.78a1.002 1.002 0 0 0 0-1.734L47.5 12.135A.998.998 0 0 0 46 13v15.563a1 1 0 0 0 .5.866"
      />
    </g>
  </svg>
);
const Memo = memo(InteractiveVideoService);
export default Memo;
